export function sortByCreation(
  a: { created_on: string | number },
  b: { created_on: string | number },
) {
  const aDate = new Date(a.created_on).getTime();
  const bDate = new Date(b.created_on).getTime();

  return aDate > bDate ? 1 : -1;
}

export function sortByName(
  a: { name?: string; created_on: string | number },
  b: { name?: string; created_on: string | number },
) {
  const aName = a.name || String(new Date(a.created_on).getTime());
  const bName = b.name || String(new Date(b.created_on).getTime());

  return aName.localeCompare(bName);
}

export function sortByCreator(
  a: { name?: string; created_by: string | number },
  b: { name?: string; created_by: string | number },
) {
  const aName = a.name || String(new Date(a.created_by).getTime());
  const bName = b.name || String(new Date(b.created_by).getTime());

  return aName.localeCompare(bName);
}

export function sortByEmail(
  a: { email?: string; created_by: string | number },
  b: { email?: string; created_by: string | number },
) {
  const aEmail = a.email || String(new Date(a.created_by).getTime());
  const bEmail = b.email || String(new Date(b.created_by).getTime());

  return aEmail.localeCompare(bEmail);
}
